import React from 'react'
import Container from '@material-ui/core/Container'
import styleClasses from '../components/common/common.module.scss'
import GuestsList from '../components/guests/GuestsList'
import cookies from '../utils/cookies'

export default function ServiceList() {
  let loggedUser
  const getLoggedUser = () => {
    try {
      const user = cookies.get('user')
      return JSON.parse(user)
    } catch (e) {
      return null
    }
  }
  loggedUser = getLoggedUser()

  return (
    <main className={styleClasses.content}>
      <Container maxWidth="lg" className={styleClasses.container}>
        <GuestsList
          building={loggedUser?.building}
          loggedUser={loggedUser}
          type="services"
        />
      </Container>
    </main>
  )
}
